import addressBookTransforms from './addressBook';
import bucketTransforms from './bucket';
import campaignsTransforms from './campaigns';
import dashboardTransforms from './dashboard';
import fulfillmentCentersTransforms from './fulfillmentCenters';
import inventoriesTransforms from './inventories';
import organizationTransforms from './organizations';
import reasonsTransforms from './reasons';
import shellTransforms from './shell';
import templatesTransforms from './templates';
import toolsTransforms from './tools';
import usersTransforms from './users';

const transforms = [
  ...bucketTransforms,
  ...usersTransforms,
  ...toolsTransforms,
  ...templatesTransforms,
  ...shellTransforms,
  ...organizationTransforms,
  ...campaignsTransforms,
  ...inventoriesTransforms,
  ...reasonsTransforms,
  ...fulfillmentCentersTransforms,
  ...dashboardTransforms,
  ...addressBookTransforms,
];

export default transforms;
